module.exports = __webpack_public_path__ + "static/media/senionHighSchool_4.6298e800.png";